class ProductCardReviewBadge {
  constructor(container) {
    this.container = container;
    this.widget = container.querySelector('.jdgm-widget');
    this.content = container.querySelector('.product-card__review-badge-content');

    if (!this.widget || !this.content) return;

    const badge = this.widget.querySelector('.jdgm-prev-badge');
    if (badge) {
      this.render(badge);
      return;
    }

    this.observer = new MutationObserver(() => {
      const loadedBadge = this.widget.querySelector('.jdgm-prev-badge');
      if (loadedBadge) {
        this.observer.disconnect();
        this.render(loadedBadge);
      }
    });
    this.observer.observe(this.widget, { childList: true, subtree: true });
  }

  render(badge) {
    const count = parseInt(badge.dataset.numberOfReviews || '0', 10);
    if (!count) return;

    const rating = parseFloat(badge.dataset.averageRating || '0').toFixed(1);

    this.content.innerHTML = `
      <svg class="product-card__review-badge-star" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10 1.5l2.6 5.6 6.1.6-4.6 4.1 1.4 6-5.5-3.2-5.5 3.2 1.4-6-4.6-4.1 6.1-.6z"></path>
      </svg>
      <span class="product-card__review-badge-rating">${rating}</span>
      <span class="product-card__review-badge-count">(${count})</span>
    `;
    this.container.hidden = false;
  }
}

function initProductCardReviewBadges(root) {
  root.querySelectorAll('[data-review-badge]').forEach((el) => new ProductCardReviewBadge(el));
}

initProductCardReviewBadges(document);

document.addEventListener('tabChange', (event) => {
  const newTab = event.detail && event.detail.selectedTab;
  if (newTab) initProductCardReviewBadges(newTab);
});

document.addEventListener('recommendations:loaded', (event) => {
  initProductCardReviewBadges(event.target);
});
